import { opaccSanitizePlugin } from '../opacc.static.js';
import { openDB } from '../../lib/idb/idb.js';

/** @module static */

/**
 * Temporäre Speicherung von HTML-Fragmenten als Storage-Objekt
 */
export class OpaccStore {

	constructor() {
		this.dbPromise = null;

        // !!! WICHTIG: Versionsnummer bei Änderungen erhöhen !!!
        this.versionNumber = 2;
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	getCurrentURI() {
		return `${window.location.pathname}${window.location.search}`;
	}

	init(storeName) {
		this.dbPromise = openDB('opaccStore', this.versionNumber, {
			upgrade(db) {
                if (db.objectStoreNames.length > 0) {
                    [db.objectStoreNames].forEach(store => {
                        db.deleteObjectStore(store[0]);
                    })
                }
				db.createObjectStore(storeName);
			}
		});
	}

	async get(storeName, key, replaceSelectors = true) {

		let data = await (await this.dbPromise).get(storeName, key);
		data = data ? JSON.parse(data) : data;

		if( replaceSelectors ){
			for (let selector in data) {
				document.querySelector( selector ).outerHTML = opaccSanitizePlugin.sanitizeContent(data[selector]);
			}
		}
		return;
	};

	async set(storeName, key, ...selectors) {
		let data = {};
		selectors.forEach(selector => {
			data[ selector ] = document.querySelector( selector ).outerHTML;
		});

		let val = JSON.stringify(data);

		return (await this.dbPromise).put(storeName, val, key);
	};

	async del(storeName, key) {
		return (await this.dbPromise).delete(storeName, key);
	};

	async clear(storeName) {
		return (await this.dbPromise).clear(storeName);
	};

	async keys(storeName) {
		return (await this.dbPromise).getAllKeys(storeName);
	};



}